/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_Ai_EngineInputs */

const en_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Engine`)
};

const de_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Engine`)
};

const fr_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur IA`)
};

const es_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor de IA`)
};

const it_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motore AI`)
};

const nl_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-motor`)
};

const pl_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silnik AI`)
};

const fi_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-moottori`)
};

const da_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-motor`)
};

const sv_onboarding_complete_ai_engine = /** @type {(inputs: Onboarding_Complete_Ai_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-motor`)
};

/**
* | output |
* | --- |
* | "AI Engine" |
*
* @param {Onboarding_Complete_Ai_EngineInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_ai_engine = /** @type {((inputs?: Onboarding_Complete_Ai_EngineInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_Ai_EngineInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_ai_engine(inputs)
	if (locale === "fr") return fr_onboarding_complete_ai_engine(inputs)
	if (locale === "es") return es_onboarding_complete_ai_engine(inputs)
	if (locale === "it") return it_onboarding_complete_ai_engine(inputs)
	if (locale === "nl") return nl_onboarding_complete_ai_engine(inputs)
	if (locale === "pl") return pl_onboarding_complete_ai_engine(inputs)
	if (locale === "fi") return fi_onboarding_complete_ai_engine(inputs)
	if (locale === "da") return da_onboarding_complete_ai_engine(inputs)
	if (locale === "sv") return sv_onboarding_complete_ai_engine(inputs)
	return en_onboarding_complete_ai_engine(inputs)
});